module.exports = __webpack_public_path__ + "img/quiz_01.13692106.jpg";